// extracted by mini-css-extract-plugin
export default {"cta":"CallToAction-module_cta__KWWPl","contain":"CallToAction-module_contain__CSJWE","text":"CallToAction-module_text__sSGHp","button":"CallToAction-module_button__HFUq7"};